import React from 'react';

const Loader = props => {
  const { isLoadin, height, size, style, children } = props;
  return isLoadin ? (
    <div className="d-flex justify-content-center align-items-center " style={{ height, flexGrow: 1, ...style }}>
      <div className="spinner-border" role="status" style={{ width: size ? size : 40, height: size ? size : 40 }}>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Loader;
